export default {
  ERROR: 'error',
  ERROR_MESSAGE: 'error__message',
  VALID: 'valid'
};
